<template>
  <ValidationProvider
    v-slot="props"
    :name="vname"
    :vid="vid"
    :rules="rules"
    :mode="mode"
    slim
  >
    <b-field
      :label="!!isHelperTooltip ? undefined : label"
      :message="showErrorMessage ? props.errors : []"
      :type="{
        'is-danger': props.errors[0],
        'is-success': showSuccess && props.valid
      }"
      :expanded="expanded"
      :grouped="grouped"
    >
      <template #label v-if="isHelperTooltip">
        <span>{{ label }}</span>
        <b-tooltip
          multilined
          type="is-dark"
          position="is-top"
          class="u-label-tooltip has-cursor-help"
          :label="helperText"
        >
          <b-icon icon="info-circle" type="is-info" />
        </b-tooltip>
      </template>
      <div>
        <slot v-bind="props" />
        <u-info v-if="isHelperInfo" class="has-margin-top-50">{{
          helperText
        }}</u-info>
      </div>
    </b-field>
  </ValidationProvider>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { HelperTextTypes } from "@upmind-automation/types";

export default defineComponent({
  name: "UField",
  props: {
    vname: { type: String, default: "" },
    mode: { type: String, default: "aggressive" },
    rules: { type: [String, Object], default: "" },
    vid: { type: String, default: "" },
    label: { type: String, default: "" },
    helperText: { type: String, default: "" },
    helperTextType: { type: String, default: HelperTextTypes.INFO },
    expanded: { type: Boolean, default: false },
    grouped: { type: Boolean, default: false },
    showSuccess: { type: Boolean, default: false },
    showErrorMessage: { type: Boolean, default: true },
    slim: { type: Boolean, default: true }
  },
  computed: {
    isHelperTooltip(): boolean {
      return (
        !!this.helperText && this.helperTextType === HelperTextTypes.TOOLTIP
      );
    },
    isHelperInfo(): boolean {
      return !!this.helperText && this.helperTextType === HelperTextTypes.INFO;
    }
  }
});
</script>

<style lang="scss" scoped>
::v-deep .help:empty {
  margin: 0;
}
.u-label-tooltip {
  transform: translate(-3px, 2px);
  text-transform: none !important;
}
</style>
